import React, { Component } from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import validate from '../../lib/validation';

import { updateField } from '../../actions/form';

export class DatePickerMobile extends Component {
  constructor(props) {
    super(props);

    this.defaultValue = new Date();
    this.onInputChange = this.onInputChange.bind(this);
    this.updateStore = this.updateStore.bind(this);
  }

  componentDidMount() {
    if (_.isEmpty(this.props.fieldValue)) {
      this.updateStore(this.defaultValue);
    }
  }

  onInputChange(event) {
    this.updateStore(event.target.value);
  }

  updateStore(value) {
    const valueAsDateObj = moment(value).toDate();
    this.props.updateField(this.props.type, this.props.field, valueAsDateObj);
  }

  validateDate() {
    const isValid = validate.run({ type: 'Date' }, this.props.fieldValue);
    if (isValid) return 'success';
    return 'error';
  }

  render() {
    return (
      <FormGroup validationState={this.validateDate()}>
        <FormControl
          type="date"
          name="date"
          value={moment(this.props.fieldValue).format('YYYY-MM-DD')}
          onChange={this.onInputChange}
        />
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  fieldValue: _.get(state, `form.${state.ui.ratingType}.fields.${ownProps.field}`, new Date()),
  type: _.get(state, 'ui.ratingType'),
});

export default connect(
  mapStateToProps,
  { updateField },
)(DatePickerMobile);
